import React, {useState} from "react";
import Dialog from "../../../components/Dialog/Dialog";
import {CircularProgress, Tooltip, withStyles} from "@material-ui/core";
import CloseIcon from "../../../components/Icon/Close";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const ModalViewerExame = ({ classes, open, onClose, url, loading }) => {
  const [fullscreen, setFullscreen] = useState(false);

  const handleOpenNewTab = () => {
    window.open(url, "_blank");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullscreen}
      classes={{ paper: fullscreen ? classes.paperFullscreen : classes.paper }}
    >
      <div className={classes.root}>
        <div className={classes.header}>
          <div className={classes.title}>Visualizar Exame</div>
          <div className={classes.headerActions}>
            <Tooltip title="Abrir em nova aba" placement="bottom">
              <div onClick={handleOpenNewTab} className={classes.actionButton}>
                <OpenInNewIcon fontSize="small" />
              </div>
            </Tooltip>
            <Tooltip title={fullscreen ? "Sair da tela cheia" : "Tela cheia"} placement="bottom">
              <div onClick={() => setFullscreen(!fullscreen)} className={classes.actionButton}>
                {fullscreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
              </div>
            </Tooltip>
            <Tooltip title="Fechar" placement="bottom">
              <div onClick={onClose} className={classes.closeButton}>
                <CloseIcon />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className={classes.content}>
          {loading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress />
            </div>
          ) : (
            <iframe
              src={url}
              title="Viewer DICOM"
              className={classes.iframe}
              allow="fullscreen"
              allowFullScreen
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

const styles = {
  paper: {
    width: "95vw",
    maxWidth: "95vw",
    height: "92vh",
    maxHeight: "92vh",
    borderRadius: "10px",
    overflow: "hidden",
    margin: "16px",
  },
  paperFullscreen: {
    width: "100vw",
    maxWidth: "100vw",
    height: "100vh",
    maxHeight: "100vh",
    borderRadius: 0,
    margin: 0,
  },
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    background: "#FAFAFA",
    minHeight: "44px",
    flexShrink: 0,
  },
  title: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#219A97",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  actionButton: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    color: "#505050",
    transition: "background 0.2s",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.06)",
    },
  },
  closeButton: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    color: "#FB7676",
    transition: "background 0.2s",
    "&:hover": {
      background: "rgba(251, 118, 118, 0.1)",
    },
  },
  content: {
    flex: 1,
    overflow: "hidden",
    position: "relative",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },
};

export default withStyles(styles)(ModalViewerExame);
